export default function ({getters, commit, dispatch}) {
    commit('loading', true);
    dispatch('list/get', {
        data: getters['form/data'],
        cb: ({items}) => {
            commit('loading');
        }
    });
    setTimeout(() => {
        commit('tab', 'list');
    }, 100)
}